// Одна корзина кошелька описана здесь один раз. Раньше подписи и поля разъезжались
// по экранам, из-за чего оператор видел суммы не в тех колонках (ENG-113).
//
// Имена полей у бэкенда историчны и не совпадают с подписями:
//   * список  /api/v2/admin/users     — алиасы сериализатора: add_sum = account.bonus_sum,
//                                        dobavka_sum = account.additive_sum;
//   * карточка /users/{id}/listing     — сырые поля account;
//   * агрегаты того же списка          — bonus_add_balance = сумма bonus_sum,
//                                        bonus_balance = сумма additive_sum.
//
// Продуктовые названия заданы в ENG-90: Points → Plus (оранжевый), Plus → Extra (зелёный).
// Значения, которые уходят на бэкенд (fill_bin, source_type, урлы ручек), не менялись.
export const WALLET_BUCKETS = [
    {
        key: "main",
        label: "Основной",
        color: "#65d6ff",
        accountField: "main_sum",
        listField: "balance_sum",
        totalField: "main_balance",
    },
    {
        key: "plus",
        label: "Plus",
        color: "#f4b860",
        accountField: "bonus_sum",
        listField: "add_sum",
        totalField: "bonus_add_balance",
    },
    {
        key: "extra",
        label: "Extra",
        color: "#57d7a7",
        accountField: "additive_sum",
        listField: "dobavka_sum",
        totalField: "bonus_balance",
    },
    {
        key: "frozen",
        label: "Накопительный",
        color: "#b8a7ff",
        accountField: null,
        listField: "ref_sum",
        listFieldOnRoot: true,
        totalField: "bonus_frozen_balance",
    },
];

export const walletBucket = (key) => {
    const bucket = WALLET_BUCKETS.find((item) => item.key === key);
    if (!bucket) throw new Error(`Неизвестная корзина кошелька: ${key}`);
    return bucket;
};

export const walletLabel = (key) => walletBucket(key).label;

// Накопительный лежит на корне строки, остальные — внутри balance.
export const walletListValue = (user, key) => {
    const bucket = walletBucket(key);
    return bucket.listFieldOnRoot ? user?.[bucket.listField] : user?.balance?.[bucket.listField];
};

export const walletAccountValue = (account, key) => {
    const bucket = walletBucket(key);
    return bucket.accountField ? account?.[bucket.accountField] : undefined;
};

export const walletTotal = (payload, key) => payload?.[walletBucket(key).totalField];
